import axios from 'axios';
import { PRICElIST_BASE_URL } from '../BaseURL';
import getHeaders from '../../constants/headers';

export const getPriceCode = storeId => {
  return axios({
    method: 'get',
    url: PRICElIST_BASE_URL + '/api/secure/v1/store/' + storeId + '/price-code',
    headers: getHeaders(),
  });
};

export const getBrandPriceCode = brandId => {
  return axios({
    method: 'get',
    url: PRICElIST_BASE_URL + '/api/secure/v1/brand/' + brandId + '/price-code',
    headers: getHeaders(),
  });
};

export const postBrandPriceCode = (brandId, data) => {
  return axios({
    method: 'post',
    url: PRICElIST_BASE_URL + '/api/secure/v1/brand/' + brandId + '/price-code',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const putBrandPriceCode = (brandId, data) => {
  return axios({
    method: 'put',
    url: PRICElIST_BASE_URL + '/api/secure/v1/brand/' + brandId + '/price-code',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const postBrandPackage = (brandId, data) => {
  return axios({
    method: 'post',
    url: PRICElIST_BASE_URL + '/api/secure/v1/brand/' + brandId + '/package',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const putBrandPackage = (brandId, data) => {
  return axios({
    method: 'put',
    url: PRICElIST_BASE_URL + '/api/secure/v1/brand/' + brandId + '/package',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const getBrandStorePrice = (brandId, storeId) => {
  return axios({
    method: 'get',
    url:
      PRICElIST_BASE_URL +
      '/api/secure/v1/brand/' +
      brandId +
      '/store-price/' +
      storeId,
    headers: getHeaders(),
  });
};

export const postBrandStorePrice = (brandId, data) => {
  return axios({
    method: 'post',
    url:
      PRICElIST_BASE_URL +
      '/api/secure/v1/brand/' +
      brandId +
      '/store-price',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};
export const putBrandStorePrice = (brandId, data) => {
  return axios({
    method: 'put',
    url:
      PRICElIST_BASE_URL +
      '/api/secure/v1/brand/' +
      brandId +
      '/store-price',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const getBrandStorePackage = (brandId, storeId) => {
  return axios({
    method: 'get',
    url:
      PRICElIST_BASE_URL +
      '/api/secure/v1/brand/' +
      brandId +
      '/store-package/' +
      storeId,
    headers: getHeaders(),
  });
};

// for web page
export const postPriceListConfigData = (brandId, data) => {
  return axios({
    method: 'post',
    url: PRICElIST_BASE_URL + '/api/secure/v1/brand/' + brandId + '/price-list-config-data',
    headers: getHeaders(),
        data: JSON.stringify(data),
  });
};

// response of above api is input of this api
export const postPriceListConfig = (brandId, data) => {
  return axios({
    method: 'post',
    url:
      PRICElIST_BASE_URL +
      '/api/secure/v1/brand/' +
      brandId +
      '/price-list-config',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const getServiceUnit = () => {
  return axios({
    method: 'get',
    url: PRICElIST_BASE_URL + '/api/secure/v1/service-unit',
    headers: getHeaders(),
  });
};